exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".introAPIkey{background-color:#f6f8fb;padding:30px}.introAPIkey .clearfix{width:610px;margin:auto;position:relative}@media (max-width: 1366px){.introAPIkey .clearfix{width:570px}}@media (max-width: 800px){.introAPIkey .clearfix{width:100%}}.introAPIkey img{margin:50px 0px}@media (max-width: 1366px){.introAPIkey img{margin:35px 0px}}.introAPIkey p{color:#405878;font-size:16px;position:absolute;left:170px;right:0;top:50%;transform:translateY(-50%)}@media (max-width: 1366px){.introAPIkey p{font-size:14px}}.emptyAPIkey{text-align:center;padding:40px 20px;margin-top:50px}.emptyAPIkey p{margin-bottom:15px}.emptyAPIkey p span{font-weight:600}.emptyAPIkey p.devDocLink{font-size:13px;margin-bottom:0}.emptyAPIkey .btn{margin-bottom:15px}@media (max-width: 1366px){.emptyAPIkey{margin-top:20px;margin-bottom:-50px;padding:35px 20px}.emptyAPIkey p{font-size:14px}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/api-key/sub/blank-state.component.scss
// module id = 1347
// module chunks = 4